import { render, staticRenderFns } from "./GradeChip.vue?vue&type=template&id=7e0d2d50&scoped=true&"
import script from "./GradeChip.vue?vue&type=script&lang=ts&"
export * from "./GradeChip.vue?vue&type=script&lang=ts&"
import style0 from "./GradeChip.vue?vue&type=style&index=0&id=7e0d2d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d2d50",
  null
  
)

export default component.exports